{
  "Earlier": "それ以前",
  "newNotification": "{newCount} 通の新規通知",
  "newNotifications": "{newCount} 通の新規通知",
  "noNotifications": "製品、仲間のユーザーとのコラボレーション、およびその他の関連する更新についての重要な情報を受け取ります。",
  "noNotificationsTitle": "通知はここに表示されます"
}
